import { S } from './AlertIcon.styles';
import type { AlertIconProps } from './AlertIcon.types';

export const AlertIcon = (props: AlertIconProps) => <S.Icon {...props} />;
